import queryString from 'query-string';

window.addEventListener('DOMContentLoaded', () => {
  // Modal Video
  const modalVideo = document.getElementById('modalVideo');
  const modalVideoIframe = document.getElementById('modalVideoIframe');

  // Get video url from button on modal show
  if (modalVideo) {
    modalVideo.addEventListener('show.bs.modal', (e) => {
      const videoBtn = e.relatedTarget;
      const videoUrl = queryString.stringifyUrl({
        url: videoBtn.getAttribute('href'),
        query: { autoplay: 1, ref: 0 },
      });

      // Update the modal iframe.
      modalVideoIframe.setAttribute('src', videoUrl);
      // additional parm if needed
      // "?autoplay=1&showinfo=0&modestbranding=1&rel=0&mute=1"
    });

    // Before hide modal stop playing video
    modalVideo.addEventListener('hide.bs.modal', () =>
      modalVideoIframe.setAttribute('src', '')
    );
  }
});
